import {mergeAttributes, Node} from '@tiptap/core'
import {VueNodeViewRenderer} from '@tiptap/vue-2'
import ComponentAPI from '@/components/Task/TipTap/Comments/ComponentAPI.vue'

export default Node.create({
  name: 'apiComponent',

  group: 'block',

  content: 'inline*',

  parseHTML() {
    return [
      {
        tag: 'api-component',
      },
    ]
  },

  renderHTML({HTMLAttributes}) {
    return ['api-component', mergeAttributes(HTMLAttributes), 0]
  },

  addNodeView() {
    return VueNodeViewRenderer(ComponentAPI)
  },
})
